const Comment = ({ name, content }) => {
    return (
        <>
            <h6>{name}</h6>
            <p>{content}</p>
        </>
    )
}

export default Comment